<template>
  <div class="employee-information">
    <div class="select-container">
      <div class="select-container-box">
        <span>部门&nbsp;&nbsp;</span>
        <el-select v-model="departmentId" filterable  size="small" @change="changeDepartName">
          <el-option
            v-for="(item, index) in departmentData"
            :key="index"
            :label="item.value"
            :value="item.key">
          </el-option>
        </el-select>
      </div>
      <div class="select-container-box">
        <span>查找&nbsp;&nbsp;</span>
        <el-input
          placeholder="请输入姓名"
          v-model="changeName"
          size="small"
          class="search-input"
          type="text"
          :maxlength="num"
          onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
          clearable>
        </el-input>
      </div>
      <div class="select-container-box">
        <span>类型&nbsp;&nbsp;</span>
            <el-radio v-model="type" :label="0">全部</el-radio>
            <el-radio v-model="type" :label="1">员工</el-radio>
            <el-radio v-model="type" :label="2">用户</el-radio>
      </div>
      <div class="select-container-box" >
        <el-button size="small"  type="info" plain @click="init()" class="query">查询</el-button>
        <el-button size="small"  type="info" plain @click="add()" class="import" v-if="type != 2">增加</el-button> 
        <el-button size="small"  type="info" plain class="add" @click="into()" style="width:84px;" v-if="edit">引入用户</el-button> 
        <el-button style="background:#0fce82;border:none" size="small"  type="info" plain class="add" @click="register()" v-if="edit">注册</el-button> 
      </div>
    </div>
    <!-- 表单内容 -->
    <div class="table-container">
      <el-table
        :data="userData.list"
        style="width:100%;"
        size="medium"
        :default-sort = "{prop: 'date', order: 'descending'}">
        <i slot="empty" style="font-style:normal">暂无数据</i>
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
          show-overflow-tooltip
          >
        </el-table-column>
        <el-table-column
          prop="loginName"
          label="用户名"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="jobName"
          label="职位"
          align="center"
          >
        </el-table-column>
        <el-table-column
          prop="phone"
          align="center"   
          show-overflow-tooltip            
          label="手机">
        </el-table-column>
        <el-table-column
          prop="entryDate"
          label="入职时间"
          align="center"
          :formatter="dataFormatter"
          >
        </el-table-column>
        <el-table-column
          v-if="$store.state.curCompany.isQlwVersion !== true"
          prop="role"
          align="center"   
          show-overflow-tooltip            
          label="角色">
        </el-table-column>
        <el-table-column
          prop="entryDate"
          label="用户状态"
          align="center"
          >
          <template slot-scope="scope">
            <div v-if="scope.row.type == 2&&scope.row.role!='系统管理员'">
              <el-switch
                :disabled="!edit"
                :value="scope.row.enable"
                @change="onOff(scope.$index, scope.row)"
              >
              </el-switch>
            </div>
            <div v-if="scope.row.type == 2&&scope.row.role=='系统管理员'">
              <el-switch
                :value="scope.row.enable"
                disabled
                @change="onOff(scope.$index, scope.row)"
              >
              </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" >
          <template slot-scope="scope">
            <span @click="handleEdit(scope.$index, scope.row)" class="content-edit">{{edit?"编辑":"查看"}}</span>
            <span
              @click="handleEditRole(scope.$index, scope.row)" class="content-edit"  v-if="scope.row.roleId != -1 && scope.row.isOwner==false && scope.row.type == 2 && $store.state.curCompany.isQlwVersion==true">
                 {{edit ? "分配基地权限" : "查看基地权限"}}
            </span>
            <span
              @click="handleEditRole(scope.$index, scope.row)" class="content-edit" v-if="scope.row.roleId != -1 && scope.row.isOwner==false && scope.row.type == 2  && $store.state.curCompany.isQlwVersion==false">
                {{edit ? "分配角色" : "查看权限"}}
            </span>
            <span
              @click="handleDelete(scope.$index, scope.row)" class="content-del" style="margin-left:5px" v-if="edit">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <base-dialog :settingDialog="settingDialog" :showDialog.sync="showDialog" @closeDialog="closeDialog" >
      <div class="employeeForm">
        <base-form :forms="forms" :rules="rules" ref="employeeForm" class="aa">
          <el-form-item prop="phone" label="手机号码" >
            <el-input v-model="forms.phone"  v-if="$store.state.curCompany.isQlwVersion==true" placeholder="请输入手机号码"  :maxlength="num11" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @blur="onPhoneBlur"
            >
            </el-input>
            <el-input v-model="forms.phone" v-else :disabled="!edit" placeholder="请输入手机号码"  :maxlength="num11" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" @blur="onPhoneBlur"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="isAdd" prop="name" label="登录名" :required="!phoneRegistered">
            <el-input
              v-model="forms.name"
              :disabled="phoneRegistered || (!edit && $store.state.curCompany.isQlwVersion!=true)"
              :placeholder="loginNamePlaceholder"
              :maxlength="num"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
          </el-form-item>
          <el-form-item v-if="isAdd" prop="password" label="密码" :required="!phoneRegistered">
            <el-input
              v-model="forms.password"
              type="password"
              :disabled="phoneRegistered || (!edit && $store.state.curCompany.isQlwVersion!=true)"
              :placeholder="passwordPlaceholder"
              :maxlength="num"
              autocomplete="new-password"
              onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
          </el-form-item>
          
          <el-form-item prop="trueName" label="真实姓名" >
            <el-input v-model="forms.trueName"  v-if="$store.state.curCompany.isQlwVersion==true" placeholder="请输入真实姓名"  :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
            <el-input v-model="forms.trueName" v-else  :disabled="!edit" placeholder="请输入真实姓名"  :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="grade" label="用户性别" >
            <el-radio v-model="forms.grade" :label="0">男</el-radio>
            <el-radio v-model="forms.grade" :label="1">女</el-radio>
            <!-- <el-select v-model="forms.grade" filterable v-if="$store.state.curCompany.isQlwVersion==true" placeholder="请选择性别">
              <el-option
                v-for="(item, index) in gradeList"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
            <el-select v-model="forms.grade" filterable v-else :disabled="!edit" placeholder="请选择性别">
              <el-option
                v-for="(item, index) in gradeList"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item prop="departmentName" label="所在部门" >
            <el-select v-if="department" v-model="forms.departmentName" filterable  placeholder="请选择所在部门" @change="changeDepartment">
              <el-option
                v-for="(item, index) in departmentList"
                :key="index"
                :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input v-else v-model="forms.departmentName" type="text" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          <el-form-item prop="jobName" label="担任职位" >
            <el-select v-if="job" v-model="forms.jobName" filterable  placeholder="请选择担任职位" @change="changeJob">
              <el-option
                v-for="(item, index) in jobList"
                :key="index"
                :label="item.value"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input v-else v-model="forms.jobName" type="text" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          <el-form-item prop="idCard" label="身份证号" :required="$store.state.curCompany.isQlwVersion==true">
            <el-input v-model="forms.idCard" v-if="$store.state.curCompany.isQlwVersion==true" placeholder="请输入身份证号"  :maxlength="num18" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
            <el-input v-model="forms.idCard" v-else :disabled="!edit" placeholder="请输入身份证号"  :maxlength="num18" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="fishBaseIdList"  label="基地">
            <el-select v-model="forms.fishBaseIdList" filterable multiple placeholder="请选择" @change="changeEmployeeBase" :disabled="!edit">
              <el-option
                v-for="item in baseSelectOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="email" label="邮箱地址" >
            <el-input v-model="forms.email"  v-if="$store.state.curCompany.isQlwVersion==true" placeholder="请输入邮箱地址"  :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
            <el-input v-model="forms.email" v-else :disabled="!edit" placeholder="请输入邮箱地址"  :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="entryDate" label="入职时间">
            <el-date-picker
              v-model="forms.entryDate"
              type="date"
              :clearable="false"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="facePhotoUrl" label="用户图片" v-if="isShowImg">
            <el-upload
              :disabled="!edit"
              :class="{ employeeHide: hideUpload }"
              :action="uploadImgUrl"
              :data="qiniuData"
              list-type="picture-card"
              :on-preview="imgPreview"
              :on-success="imgSuccess"
              :on-change="imgChange"
              :on-remove="imgRemove"
              :before-upload="imgBefore"
              :limit="uploadLimit"
              :headers="headers"
              :file-list="imgList"
              ref="imgUpload"
              >
              <i class="el-icon-plus">
                <h4 class="upload-tip"></h4>
              </i>
              <el-dialog
                  :visible.sync="isShowImgDialog"
                  :append-to-body="true"
                >
                  <img width="100%" :src="dialogImageUrl" alt="" />
                </el-dialog>
            </el-upload>
          </el-form-item>
          <div class="dialog-footer" v-if="edit">
            <el-button @click="cancel('form')">取 消</el-button>
            <el-button type="primary" @click="save('form')">保 存</el-button>
          </div>
        </base-form>
      </div>
      
    </base-dialog>
        <!-- 引入弹窗 -->
    <div v-if="dialog" class="user">
      <el-dialog title="邀请用户"  :visible.sync="dialog" width="766px"  >
        <el-form :model="form" :rules="rule" ref="importForm" class="form">
          <el-form-item prop="userId" >
            <el-input v-model="form.userId" clearable placeholder="请输入被引入人员的手机号"  :maxlength="num" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"
            >
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="intoUsers('form')" type="primary">引入</el-button>
        </div>
        <!-- <div slot="footer" class="tip">
          <p>请输入用户名邀请用户</p>
          <br/>
          <p>(智农通用户名位置：我的---头像---个人资料---登录名)</p>
        </div> -->
      </el-dialog>
    </div>
    
    <!-- 分配角色弹窗 -->
    <div  v-if="dialogFormVisibles" class="role">
      <el-dialog title="权限分配"  :visible.sync="dialogFormVisibles" width="766px"  >
        <el-form :model="roleForm" :rules="roleRules" ref="roleForm" class="forms">
          <el-form-item prop="user"  label="用户名" :label-width="formLabelWidth" >
            <el-input v-model="roleForm.user" disabled>
            </el-input>
          </el-form-item>
          <el-form-item prop="name"  label="姓名" :label-width="formLabelWidth" >
            <el-input v-model="roleForm.name" disabled  >
            </el-input>
          </el-form-item>
          <el-form-item prop="phone"  label="手机号" :label-width="formLabelWidth" >
            <el-input v-model="roleForm.phone" disabled>
            </el-input>
          </el-form-item>
          <el-form-item prop="baseId"  label="基地" :label-width="formLabelWidth" >
            <el-select v-model="roleForm.baseId" filterable multiple placeholder="请选择" @change="changeRoleBase" v-if="$store.state.curCompany.isQlwVersion==true">
              <el-option
                v-for="item in baseSelectOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
            <el-select v-model="roleForm.baseId" filterable multiple placeholder="请选择" @change="changeRoleBase" v-else :disabled="!edit">
              <el-option
                v-for="item in baseSelectOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="$store.state.curCompany.isQlwVersion !== true" prop="roleName"  label="角色" :label-width="formLabelWidth" >
            <el-select v-model="roleForm.roleName" filterable placeholder="请选择" :disabled="!edit">
              <el-option
                v-for="(item, index) in roleList"
                :key="index"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <div class="dialog-footer" v-if="$store.state.curCompany.isQlwVersion==true&&edit">
            <el-button @click="cancelRole('roleForm')">取 消</el-button>
            <el-button type="primary" @click="saveRole('roleForm')">保 存</el-button>
          </div>
          <div class="dialog-footer" v-if="$store.state.curCompany.isQlwVersion==false&&edit">
            <el-button @click="cancelRole('roleForm')">取 消</el-button>
            <el-button type="primary" @click="saveRole('roleForm')">保 存</el-button>
          </div>
        </el-form>
        
      </el-dialog>
    </div>
    <page-change :pageInfo="pageInfo"></page-change>
  </div>
</template>

<script>
import Url from "../../../../service/base-url.js";
import { mapActions, mapState, mapMutations } from "vuex";
import { modules } from "../../../../store";
import PageChange from "../../../common/PageChange";
import BaseDialog from "./BaseDialog";
import BaseForm from "./BaseForm";
import checkPermission from "../../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "EmployeeInformation",
  mixins: [mixins],
  components: {
    PageChange,
    BaseDialog,
    BaseForm
  },
  data() {
    return {
      isShowImg: true,
      // 可上传数量
      uploadLimit: 1,
      // 上传添加头部信息
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        method: "post"
      },
      // 图片服务器上传地址
      uploadImgUrl: "https://up-z2.qiniup.com",
      qiniuData: {
        token: "",
        key: ""
      },
      photoName: "",
      // 图片列表
      imgList: [],
      // 图片预览框
      dialogImageUrl: "",
      isShowImgDialog: false,
      // 是否隐藏图片上传框
      hideUpload: false,
      departmentData: [], //部门列表用于列表页
      departmentList: [], //用于添加编辑页
      jobList: [],
      department: true, //判断部门有无
      job: true, //判断职位有无
      num: 50,
      num11: 11,
      num18: 18,
      dialog: false, //引入弹窗
      form: {
        userId: "" //引入用户
      },
      rule: {
        userId: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }
        ]
      },
      dialogFormVisibles: false, //角色分配弹窗
      formLabelWidth: "70px",
      roleList: [],
      allBaseKey: -1,
      baseList: [],
      roleForm: {
        id: "",
        user: "",
        name: "",
        phone: "",
        baseId: "",
        roleName: "",
        roleId: ""
      },
      datas: [],
      roleRules: {
        baseId: [
          {
            required: true,
            message: "请先选择基地",
            trigger: "change"
          }
        ],
        user: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur"
          }
        ],
        roleName: [
          {
            required: true,
            message: "请先选择角色",
            trigger: "change"
          }
        ]
      },
      gradeList: [
        {
          key: 0,
          value: "男"
        },
        {
          key: 1,
          value: "女"
        }
      ],
      forms: {
        id: "",
        name: "",
        trueName: "",
        grade: 0,
        phone: "",
        password: "",
        idCard: "",
        email: "",
        departmentId: "",
        departmentName: "",
        jobId: "",
        jobName: "",
        entryDate: new Date(),
        // 图片名称
        facePhotoUrl: []
      },
      phoneRegistered: false,
      checkingPhone: false,
      rules: {
        name: [
          {
            validator: (rule, value, callback) => {
              if (!this.isAdd || this.phoneRegistered) {
                callback();
                return;
              }
              if (!value) {
                callback(new Error("请输入登录名"));
                return;
              }
              if (!/^[a-zA-Z0-9]+$/.test(value)) {
                callback(new Error("用户姓名只能输入大小写英文和数字"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        trueName: [
          {
            required: true,
            pattern: /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/,
            message: "真实姓名格式有误,请重新输入",
            trigger: "blur"
          }
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (!this.isAdd || this.phoneRegistered) {
                callback();
                return;
              }
              if (!value) {
                callback(new Error("请输入密码"));
                return;
              }
              if (value.length < 6 || value.length > 20) {
                callback(new Error("密码长度为6-20位"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        grade: [
          {
            required: true,
            message: "请选择性别",
            trigger: "change"
          }
        ],
        // departmentName: [
        //   {
        //     required: true,
        //     trigger: "change",
        //     message: "部门不为空"
        //   }
        // ],
        // jobName: [
        //   {
        //     required: true,
        //     trigger: "change",
        //     message: "职位不为空"
        //   }
        // ],
        idCard: [
          {
            validator: (rule, value, callback) => {
              const isQlw = this.$store.state.curCompany.isQlwVersion === true;
              const pattern = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
              // 企联网必填
              if (isQlw && !value) {
                callback(new Error("请先填写身份证号"));
                return;
              }
              // 有值时校验格式（非企联网可留空）
              if (value && !pattern.test(value)) {
                callback(new Error("身份证格式不对,请重新输入"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        email: [
          {
            pattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "邮箱地址格式不对,请重新输入"
          }
        ],
        phone: [
          { required: true, message: "请先填写手机号码", trigger: "blur" },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号码格式不对,请重新输入"
          }
        ]
      },
      settingDialog: {
        visible: true,
        titleName: "增加员工信息",
        dialogWidth: "760px"
      },
      showDialog: false,
      changeName: "",
      departmentId: "",
      type: 0,
      PageIndex: 1,
      PageSize: 10,

      userData: {
        list: [
          {
            id: 0,
            name: "",
            grade: "",
            phone: "",
            entryDate: ""
          }
        ],
        total: 0
      },
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.init, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  async mounted() {
    // this.forms.grade = this.gradeList[0].key;
    await this.initPagePermission(this.$route, { permissionId: this.permission.peopleManage });
    this.init();
    let data = await this.getDepartment(0);
    this.departmentData = [
      {
        key: "",
        value: "全部"
      }
    ].concat(data);
    this.getToken();
    this.baseList = await this.getAllBaseLists();
  },
  methods: {
    //接口
    ...mapActions(modules.personManagement, [
      "getUserEmployee", //获取用户员工分页
      "deleteUser", // 删除员工
      "deleteUserAndEmployee", //删除用户和员工
      "addUser",
      "checkUserLoginPhone",
      "getUserView",
      "editUser",
      "getDepartment" //获取部门列表或职位列表
    ]),
    ...mapActions(modules.userManage, [
      "searchUser", //搜索用户
      "intoUser", //引入用户
      "isOnOFF", //是否开启权限
      "getEditRole", //获取单行角色权限数据
      "getRoleData", //获取角色下拉数据
      "updateCharacter"
    ]),
    ...mapMutations(modules.userManage, ["setOnOff"]),
    ...mapActions(modules.base, ["getAllBaseLists"]),
    async ensureBaseList() {
      if (!this.baseList || !this.baseList.length) {
        this.baseList = (await this.getAllBaseLists()) || [];
      }
    },
    // 基地多选：「全部」与具体基地互斥。选中全部时只保留 -1，后续新增基地自动有权限
    changeEmployeeBase(val) {
      this.forms.fishBaseIdList = this.keepAllBaseExclusive(val);
    },
    changeRoleBase(val) {
      this.roleForm.baseId = this.keepAllBaseExclusive(val);
    },
    keepAllBaseExclusive(val) {
      const list = Array.isArray(val) ? val.slice() : [];
      if (!list.length) return [];
      if (list[list.length - 1] === this.allBaseKey) return [this.allBaseKey];
      if (list.indexOf(this.allBaseKey) >= 0) {
        return list.filter(id => id !== this.allBaseKey);
      }
      const realIds = (this.baseList || []).map(item => item.key);
      if (realIds.length && list.length === realIds.length && realIds.every(id => list.indexOf(id) >= 0)) {
        return [this.allBaseKey];
      }
      return list;
    },
    // emptyAsAll：未分配过基地时默认「全部」（新增、首次分配角色）
    toBaseSelection(ids, emptyAsAll) {
      const list = Array.isArray(ids) ? ids.slice() : [];
      const same = (a, b) => String(a) === String(b);
      if (list.some(id => same(id, this.allBaseKey))) return [this.allBaseKey];
      const realIds = (this.baseList || []).map(item => item.key);
      if (realIds.length && list.length === realIds.length && realIds.every(id => list.some(item => same(item, id)))) {
        return [this.allBaseKey];
      }
      if (!list.length && emptyAsAll) return [this.allBaseKey];
      return list;
    },
    // 上传图片
    async getToken() {
      let res = await this.$api.getToken();
      if (res.data.code == 0) {
        let token = res.data.data;
        this.qiniuData.token = token;
      }
    },
    imgBefore() {
      this.qiniuData.key = this.guid();
    },
    // 图片上传成功
    imgSuccess(response) {
      this.photoName = "https://nfs.nxin.com/" + response.key;
      this.forms.facePhotoUrl = [this.photoName];
    },

    // 图片上传改变
    imgChange(file, fileList) {
      this.hideUpload = fileList.length >= this.uploadLimit;
    },
    // 图片移除
    imgRemove(file, fileList) {
      if (fileList.length == 0) {
        this.imgList = [];
        this.forms.facePhotoUrl = [];
        this.photoName = "";
      }
      this.hideUpload = fileList.length >= this.uploadLimit;
    },
    // 图片预览
    imgPreview(file) {
      this.dialogImageUrl = file.url;
      this.isShowImgDialog = true;
    },

    // 初始化列表
    async init() {
      this.userData = await this.getUserEmployee({
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize,
        QueryString: this.changeName,
        DepartmentId: this.departmentId,
        type: this.type
      });
      this.pageInfo.totalPages = this.userData.total;
    },
    //改变部门查询列表数据
    async changeDepartName(value) {
      this.userData = await this.getUserPage({
        PageIndex: this.pageInfo.pageNumber,
        PageSize: this.pageInfo.pageSize,
        QueryString: this.changeName,
        DepartmentId: value
      });
      this.pageInfo.totalPages = this.userData.total;
    },
    //获取部门列表或职位列表
    async getDepartmentList() {
      this.departmentList = await this.getDepartment(0);
      this.departmentList.push({ value: "添加部门", key: 1000 });
      if (this.departmentList && this.departmentList.length !== 0) {
        this.department = true;
        this.job = true;
        this.forms.departmentName = this.departmentList[0].value;
        this.changeDepartment(this.forms.departmentName);
      } else {
        this.job = false;
        this.department = false;
      }
    },
    //切换部门,获取职位列表
    async changeDepartment(value) {
      // 是否选择自定义
      if (value == "添加部门") {
        this.forms.departmentName = "";
        this.forms.departmentId = null;
        this.forms.jobName = "";
        this.forms.jobId = null;
        this.department = false;
        this.job = false;
      } else {
        this.department = true;
        this.job = true;
        let item = this.departmentList.find(f => f.value == value);
        if (item) {
          this.forms.departmentId = item.key;
          this.forms.departmentName = value;
          this.jobList = await this.getDepartment(item.key);
          this.jobList.push({ value: "添加职位", key: 1001 });
          if (this.jobList && this.jobList.length !== 0) {
            this.job = true;
            this.forms.jobName = this.jobList[0].value;
            this.changeJob(this.forms.jobName);
          } else {
            this.job = false;
          }
        }
      }
    },
    //切换职位
    changeJob(value) {
      // 是否选择自定义
      if (value == "添加职位") {
        this.forms.jobName = "";
        this.forms.jobId = null;
        this.job = false;
      } else {
        this.job = true;
        let item = this.jobList.find(f => f.value == value);
        if (item) {
          this.forms.jobId = item.key;
          this.forms.jobName = item.value;
        }
      }
    },
    //时间格式化
    dataFormatter(row, column) {
      var date = row.entryDate;
      if (date == undefined) {
        return "";
      }
      return this.$timeformatDay(row.entryDate);
    },
    // 添加按钮
    async add() {
      await this.ensureBaseList();
      this.phoneRegistered = false;
      this.checkingPhone = false;
      this.forms = {
        id: "",
        name: "",
        trueName: "",
        grade: null,
        phone: "",
        password: "",
        idCard: "",
        email: "",
        entryDate: new Date(),
        departmentId: null,
        departmentName: "",
        jobId: null,
        jobName: "",
        fishBaseIdList: [this.allBaseKey],
      };

      this.isShowImg = true;
      this.hideUpload = false;
      this.imgList = [];
      this.settingDialog.titleName = "增加员工信息";
      this.showDialog = true;
      this.forms.grade = this.gradeList[0].key;
      await this.getDepartmentList();
    },
    // 取消按钮
    cancel(formName) {
      this.closeDialog();
    },
    // 关闭弹窗
    closeDialog() {
      this.showDialog = false;
      this.phoneRegistered = false;
      this.checkingPhone = false;
      this.$refs.employeeForm.$refs.form.resetFields();
    },
    onPhoneBlur() {
      if (!this.isAdd) return;
      const phone = (this.forms.phone || "").trim();
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.phoneRegistered = false;
        return;
      }
      this.checkingPhone = true;
      this.checkUserLoginPhone(phone)
        .then(data => {
          this.phoneRegistered = !!(data && data.exists);
          if (this.phoneRegistered) {
            this.forms.name = "";
            this.forms.password = "";
            if (data.realName && !this.forms.trueName) {
              this.forms.trueName = data.realName;
            }
          }
          this.$nextTick(() => {
            if (this.$refs.employeeForm && this.$refs.employeeForm.$refs.form) {
              this.$refs.employeeForm.$refs.form.validateField("name");
              this.$refs.employeeForm.$refs.form.validateField("password");
            }
          });
        })
        .catch(err => {
          this.phoneRegistered = false;
          this.$message.error((err && err.response && err.response.data) || "校验手机号失败");
        })
        .then(() => {
          this.checkingPhone = false;
        });
    },
    // 点击保存
    save(formName) {
      this.$refs.employeeForm.$refs[formName].validate(valid => {
        if (valid) {
          let pageIndex = this.pageInfo.pageNumber;
          if (this.pageInfo.totalPages % 10 === 1) {
            pageIndex -= 1;
          }
          // 提交 trueName / password（对应后端 TrueName / Password）；编辑时密码留空则不提交
          let payload = Object.assign({}, this.forms);
          if (payload.id && !payload.password) {
            delete payload.password;
          }
          if (!payload.id && this.phoneRegistered) {
            payload.name = "";
            payload.password = "";
          }
          // 编辑员工信息
          if (this.forms.id) {
            if (this.$store.state.curCompany.isQlwVersion == true) {
              this.settingDialog.titleName = "编辑员工信息";
            } else if (
              this.$store.state.curCompany.isQlwVersion == false &&
              this.edit == true
            ) {
              this.settingDialog.titleName = "编辑员工信息";
            } else if (
              this.$store.state.curCompany.isQlwVersion == false &&
              this.edit == false
            ) {
              this.settingDialog.titleName = "查看员工信息";
            }
            this.editUser(payload)
              .then(() => {
                this.init(pageIndex);
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.$refs.employeeForm.$refs[formName].resetFields();
                this.showDialog = false;
              })
              .catch(err => {
                this.$message.error(err.response.data);
              });
          } else {
            // 添加员工信息
            this.settingDialog.titleName = "添加员工信息";
            this.addUser(payload)
              .then(() => {
                this.init(pageIndex);
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                this.$refs.employeeForm.$refs[formName].resetFields();
                this.showDialog = false;
              })
              .catch(err => {
                this.$message.error(err.response.data);
              });
          }
        }
      });
    },
    // 点击编辑
    async handleEdit(index, row) {
      // console.log(1222, row);
      await this.ensureBaseList();
      this.phoneRegistered = false;
      this.checkingPhone = false;
      if (row.type == 2) {
        this.isShowImg = false;
      } else {
        this.isShowImg = true;
      }

      this.department = true;
      this.job = true;
      this.departmentList = await this.getDepartment(0);
      this.departmentList.push({ value: "添加部门", key: 1000 });
      this.jobList = await this.getDepartment(row.departmentId);
      this.jobList.push({ value: "添加职位", key: 1001 });

      if (this.$store.state.curCompany.isQlwVersion == true) {
        this.settingDialog.titleName = "编辑员工信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == true
      ) {
        this.settingDialog.titleName = "编辑员工信息";
      } else if (
        this.$store.state.curCompany.isQlwVersion == false &&
        this.edit == false
      ) {
        this.settingDialog.titleName = "查看员工信息";
      }
      this.getUserView(row.id)
        .then(data => {
          this.showDialog = true;
          this.forms = Object.assign({}, data, {
            // 登录名 ← LoginName；真实姓名 ← TrueName（兼容旧数据仅有 name）
            name: data.loginName || data.LoginName || "",
            trueName: data.trueName || data.TrueName || data.name || "",
            password: "",
            fishBaseIdList: this.toBaseSelection(data.fishBaseIdList, false)
          });
          if (data.facePhotoUrl && data.facePhotoUrl.length) {
            this.forms.photoName = data.facePhotoUrl[0];
            this.hideUpload = true;
            this.imgList = [
              {
                name: data.facePhotoUrl[0],
                url: data.facePhotoUrl[0]
              }
            ];
          } else {
            this.hideUpload = false;
            this.imgList = [];
          }
        })
        .catch(err => {
          this.$message.error(err.response.data);
        });
    },
    // 删除
    handleDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let params = {
            userId: row.id,
            versionType: 1,
            isDeleteRelevance: this.type === 0
          }
          await this.deleteUserAndEmployee(params);
          this.init(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
        });
    },
    //是否开启权限
    onOff(index, row) {
      let result = this.isOnOFF({
        userId: row.id,
        enable: !row.enable,
        index: index
      })
        .then(rsp => {
          let obj = {
            userId: row.id,
            enable: row.enable,
            index: index
          };
          this.userData.list[obj.index].enable = !obj.enable;
        })
        .catch(err => {
          this.$message.error(err.response.data);
        });
    },
    //注册
    register() {
      console.log(Url.registerUrl);
      window.open(Url.registerUrl);
    },
    //点击引入
    into() {
      this.dialog = true;
      this.form.userId = "";
    },
    //保存引入
    async intoUsers() {
      this.searchUser(this.form.userId)
        .then(result => {
          this.userList = result;

          if (this.userList.length != 0) {
            this.id = this.userList[0].key;
            console.log("968", this.id);
            this.intoUser({
              userId: this.id
            })
              .then(rsp => {
                console.log("rsp", rsp);
                this.init();
                this.$message({
                  message: "引入成功",
                  type: "success"
                });
                this.dialog = false;
                this.form.userId = "";
              })
              .catch(err => {
                console.log(err.response.data);
                this.$message.error(err.response.data);
              });
          } else {
            this.$message.error("手机号不存在，请重新输入");
          }
        })
        .catch(err => {
          console.log(err.response.data);
          this.$message.error(err.response.data);
        });
    },
    //进入分配角色窗口
    async handleEditRole(index, row) {
      await this.ensureBaseList();
      this.dialogFormVisibles = true;
      this.roleList = await this.getRoleData();
      let result = await this.getEditRole(row.id);

      this.roleForm.name = result.name;
      this.roleForm.user = result.loginName;
      this.roleForm.phone = result.phone;
      this.roleForm.id = result.id;
      this.roleForm.roleName = result.roleId;
      this.roleForm.baseId = this.toBaseSelection(result.fishBases, true);
    },
    //取消角色分配
    cancelRole() {
      this.dialogFormVisibles = false;
    },
    //保存角色分配
    saveRole(formName) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      console.log(3455, this.datas);

      this.$refs[formName].validate(valid => {
        if (valid) {
          this.updateCharacter({
            userId: this.roleForm.id,
            fishBases: this.roleForm.baseId,
            roleId: this.roleForm.roleName
          })
            .then(() => {
              this.init(pageIndex);
              this.$message({
                message: "保存成功",
                type: "success"
              });
              this.dialogFormVisibles = false;
            })
            .catch(error => {
              this.$message({
                message: error,
                type: "success"
              });
            });
        }
      });
    }
  },
  computed: {
    isAdd() {
      return !this.forms.id;
    },
    baseSelectOptions() {
      return [{ key: this.allBaseKey, value: "全部" }].concat(this.baseList || []);
    },
    loginNamePlaceholder() {
      return this.phoneRegistered ? "使用原账号登录" : "请输入登录名";
    },
    passwordPlaceholder() {
      return this.phoneRegistered ? "使用原账号登录" : "请输入密码";
    },
    // 获取 是否为企联网
    whetherQlw() {
      return this.curCompany.isQlwVersion;
    }
  },
  watch: {
    whetherQlw() {
      this.initPagePermission(this.$route, { permissionId: this.permission.peopleManage });
    },
    "forms.phone"(val) {
      if (!this.isAdd) return;
      this.phoneRegistered = false;
      this.forms.password = "";
    }
  }
};
</script>
<style lang="stylus">
.employeeHide{
  .el-upload{
    display: none;
  }
}
  
    
.employee-information
  
  
  .el-table
    border-top 2px solid rgba(51, 137, 255, 1)!important
  .el-form-item__label:before {
    left: 8px;
    font-size: 18px;
    color: #fe3223;
  }
  .PageChange{
    justify-content: center;
    margin-top:-15px;
  }
  .content-container .titieMian .select-container{
    height:86px;
  }
  .table-container{
    border:none;
    padding:20px 20px 0px 20px;
  }
  .aa{
    .el-form-item {
      margin-bottom: 14px;
    }
    
  }
  // 公共部分
  .el-dialog
    border-radius:6px;
    overflow:hidden;
    
    .el-dialog__header 
      padding: 16px 20px 16px;
      background:linear-gradient(270deg,rgba(51,137,255,1),rgba(31,156,244,1),rgba(49,170,255,1));
      .el-dialog__title 
        color: #fff;
    .el-input
      width:500px;
    .el-input__inner
      width:500px;
      height: 44px;
    .el-form-item__content
      z-index:999999;
      position: relative;
      bottom:-5px;
      font-size: 14px;
    .el-form .el-form-item .el-form-item__label
      margin-top:6px;
      margin-left:65px;
      text-align:right;
    .ruleForm
      margin-left 0px
    .el-dialog__close 
      color:#fff
    .el-form-item__error {
      color: #f56c6c;
      font-size: 12px;
      line-height: 1;
      padding-top: 8px;
      position: absolute;
      top: 100%;
      left: 19px;
    }
   
    //分配角色
  .role
    .el-dialog
      // height:550px;
      .el-input__inner
        margin-left:10px;
      .el-dialog__footer
        text-align left
        position relative
        bottom:12px;
        padding:0px 106px 0px
       .el-button--primary
        margin-left:20px
        background: #3389ff;
      .el-button
        width 100px
        height 40px
      .el-button--default
        margin-left:34px
      .el-form-item .el-form-item__label:before
        position: absolute;
        top: 2px;
        left: -13px;
        color: #fe3223;
      .el-form-item__error
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 2px;
        position: absolute;
        top: 100%;
        left: 75px;
      .el-select .el-tag 
        margin: 2px 0 2px 15px;
      .dialog-footer
        margin-left:110px;
        margin-top:40px;
    

  //引入用户
  .user
    .el-dialog
      position relative
      height:200px;
      .el-form-item
        width:500px;
        .el-input__inner
          margin-left:50px;
          height:40px;
      .dialog-footer
        margin-left:120px;
        margin-top:0px;
        z-index:999999;
        width:100px;
        position absolute
        top:92px;
        right:80px;
        .el-button--primary
          margin-left:7px;
          background: #3389ff;
          width 100px
          height 40px
      .tip
        position relative
        bottom:132px;
        text-align center;
        right:1px;
        color:#666;
      p
        position relative;
        top:100px;
      .el-form-item__error
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 2px;
        position: absolute;
        top: 100%;
        left: 40px;
      .el-input__suffix
        position absolute;
        right:-30px;
</style>
